jQuery(document).ready(function ($) {
    BasicBootstrap();
    url2tabpos();
});

window.BasicBootstrap = function (nodezero) {
    //KTHeadshot.init(nodezero);
    KTCalendar.init(nodezero);
    KTDatepicker.init(nodezero);
    KTSelect.init(nodezero);
    KTOffcanvasPanel.init(nodezero);
    KTAsideMenuPanel.init(nodezero);
    KTCardSticky.init(nodezero);
    KTWizardPanel.init(nodezero);
    // NPAsideToggle.init(nodezero);
    NPToggleAccordionOnTab.init(nodezero);
    KTInputmask.init();
    KTBlockUI.init();
	KTAppInbox.init();
    KTCkeditor.init(nodezero);
    KTMarkdown.init();
	NPClipboard.init(nodezero);
	KTPopovers.init();
	KTTooltips.init();
}


function url2tabpos() {
    let url = location.href.replace(/\/$/, "");

    if (location.hash) {
        const hash = url.split("#");

        if ($('.nav-item a[href="#' + hash[1] + '"]').length) {
            $('.nav-item a[href="#' + hash[1] + '"]').tab("show");
            url = location.href.replace(/\/#/, "#");
            history.replaceState(null, null, url);
            setTimeout(() => {
                $(window).scrollTop(0);
            }, 400);
        }
    }
    $('a[data-toggle="tab"]').on("click", function () {
        let newUrl;
        const hash = $(this).attr("href");
        if (hash == "#home") {
            newUrl = url.split("#")[0];
        } else {
            newUrl = url.split("#")[0] + hash;
        }
        // newUrl += "/";
        history.replaceState(null, null, newUrl);
    });

}

window.showModal = function (parms) {
    KTApp.blockPage({ opacity: 0.15, state: 'primary', message: 'Please wait...' });
    Livewire.dispatch('showModal', { parms: parms });
}

window.npClipboards = [];
var NPClipboard = function () {
    return {
        // public functions
        init: function (nodezero) {
            var selector = nodezero ? nodezero + ' [data-toggle="clipboard"]' : '[data-toggle="clipboard"]';
            // console.log(selector);
            $(selector).each(function (idx, ele) {
                // console.log(selector);
                if (!($(this).attr('data-clipboard-text') in npClipboards)) {
                    // console.log(npClipboards);
                    // console.log(ele.closest('.modal-dialog'));
                    options = ele.closest('.modal-dialog') ? { container: ele.closest('.modal-dialog') } : {};
                    var clipboard = new ClipboardJS(ele, options).on('success', function (e) {
                        // console.log(e);
                        $(e.trigger).tooltip({ trigger: 'manual', title: 'Copied!' });
                        $(e.trigger).tooltip('show');
                        setTimeout(function () { $(e.trigger).tooltip('hide'); }, 1000);
                    }).on('error', function (e) {
                        console.error('Action:', e.action);
                        console.error('Trigger:', e.trigger);
                    });
                    npClipboards[selector + $(this).attr('data-clipboard-text')] = clipboard;
                }
            });
        }
    };
}();

var KTHeadshot = function () {
    return {
        // public functions
        init: function (nodezero) {
            var selector = nodezero ? nodezero + ' div[data-toggle="headshot"]' : 'div[data-toggle="headshot"]';
            $(selector).each(function (idx, ele) {
                _avatar = new KTImageInput($(this).attr('id'));
            });
        }
    };
}();

var KTCalendar = function () {
    return {
        // calendar supports different event sources see: https://fullcalendar.io/docs/events-json-feed
        init: function (nodezero) {
            var selector = nodezero ? nodezero + ' div[data-toggle="calendar"]' : 'div[data-toggle="calendar"]';
            $(selector).each(function (idx, ele) {
                var _settings = $('#settings_for_' + $(this).attr('id')).text() ?? null;
                _settings = _settings ? JSON.parse(_settings) : null;

                if (typeof _settings === 'object' && _settings !== null) {
                    var calendar = new FullCalendar.Calendar(this, {
                        locale: _settings.locale ?? null,
                        headerToolbar: {
                            left: 'prev,next today',
                            center: 'title',
                            right: _settings.headerToolbarRight ?? 'dayGridYear,dayGridMonth,timeGridWeek,listYear'    // 'dayGridYear,dayGridMonth,timeGridWeek,timeGridDay,listYear,listMonth,listWeek,listDay'
                        },
                        height: 800,
                        contentHeight: 750,
                        aspectRatio: 3,  // see: https://fullcalendar.io/docs/aspectRatio
                        initialView: _settings.initialView ?? 'dayGridMonth',
                        initialDate: _settings.initialDate,
                        editable: true,
                        dayMaxEventRows: true, // allow "more" link when too many events
                        navLinks: true,
                        events: _settings.events,
                        visibleRange: _settings.visibleRange ?? null,
                        validRange: _settings.validRange ?? null,
                    });
                    calendar.render();
                }
            });
        }

        // calendar supports different event sources see: https://fullcalendar.io/docs/v4/events-json-feed
        // init: function() {
        //     // var todayDate = moment().startOf('day');
        //     // var TODAY = todayDate.format('YYYY-MM-DD');
        //     var _settings = $('#settings_for_' + $(this).attr('id')).text() ?? null;

        //     var calendarEl = document.getElementById('calendar-{{$this->cdef}}');
        //     var calendar = new FullCalendar.Calendar(calendarEl, {
        //         plugins: [ 'interaction', 'dayGrid', 'timeGrid', 'list' ],
        //         isRTL: KTUtil.isRTL(),
        //         header: {
        //             left: 'prev,next today',
        //             center: 'title',
        //             right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
        //         },
        //         height: 800,
        //         contentHeight: 750,
        //         aspectRatio: 3,  // see: https://fullcalendar.io/docs/aspectRatio
        //         views: {
        //             dayGridMonth: { buttonText: 'month' },
        //             timeGridWeek: { buttonText: 'week' },
        //             timeGridDay: { buttonText: 'day' },
        //             listDay: { buttonText: 'list' },
        //             listWeek: { buttonText: 'list' }
        //         },
        //         defaultView: 'dayGridMonth',
        //         defaultDate: "{!! $_defaultDate !!}",
        //         editable: true,
        //         eventLimit: true, // allow "more" link when too many events
        //         navLinks: true,
        //         // events: {!! json_encode($_events) !!},
        //         eventRender: function(info) {
        //             var element = $(info.el);

        //             if (info.event.extendedProps && info.event.extendedProps.description) {
        //                 if (element.hasClass('fc-day-grid-event')) {
        //                     element.data('content', info.event.extendedProps.description);
        //                     element.data('placement', 'top');
        //                     KTApp.initPopover(element);
        //                 } else if (element.hasClass('fc-time-grid-event')) {
        //                     element.find('.fc-title').append('<div class="fc-description">' + info.event.extendedProps.description + '</div>');
        //                 } else if (element.find('.fc-list-item-title').lenght !== 0) {
        //                     element.find('.fc-list-item-title').append('<div class="fc-description">' + info.event.extendedProps.description + '</div>');
        //                 }
        //             }
        //         }
        //     });

        //     calendar.render();
        // }
    };
}();

var KTDatepicker = function () {
    return {
        // public functions
        init: function (nodezero) {
            var selector = nodezero ? nodezero + ' input[data-toggle="timepicker"],' + nodezero + ' input[data-toggle="daterangepicker"]' : 'input[data-toggle="timepicker"], input[data-toggle="daterangepicker"]';
            $(selector).each(function (idx, ele) {
                var _toggle = $(this).data('toggle') ?? null;
                var _settings = $('#settings_for_' + $(this).attr('id')).text() ?? null;
                _settings = _settings ? JSON.parse(_settings) : null
                // console.log(_settings);

                if (typeof _settings === 'object' && _settings !== null) {
                    switch (_toggle) {
                        case 'timepicker':          // http://jdewit.github.io

                            $(this).timepicker(_settings);
                            break;

                        case 'daterangepicker':     // http://www.daterangepicker.com

                            $(this).daterangepicker(_settings).on('apply.daterangepicker', function (ev, picker) {
                                // console.log(ev, picker);
                                if (!picker.singleDatePicker) {
                                    $(this).val(picker.startDate.format(picker.locale.format) + picker.locale.separator + picker.endDate.format(picker.locale.format));
                                } else {
                                    $(this).val(picker.startDate.format(picker.locale.format));
                                }
                                this.dispatchEvent(new InputEvent('input'));
                            }).on('cancel.daterangepicker', function (ev, picker) {
                                // console.log(ev, picker);
                                $(this).val('');
                                this.dispatchEvent(new InputEvent('input'));
                            });
                            break;

                        default:
                            // when none match...
                            break;
                    }
                }
            });
        }
    };
}();

window.ckEditors = [];
var KTCkeditor = function () {
    return {
        // public functions
        init: function (nodezero) {
            var selector = nodezero ? nodezero + ' textarea[data-provide="ckeditor"]' : 'textarea[data-provide="ckeditor"]';
            $(selector).each(function (idx, ele) {
                _attrModel = $(this).attr('wire:model.live') ?? $(this).attr('wire:model') ?? $(this).attr('wire:model.blur');
                if (!(_attrModel in ckEditors)) {
                    ckEditors[_attrModel] = 'promised';
                    ClassicEditor
                        .create(this, {
                            //removePlugins: ['EasyImage', 'Image', 'ImageStyle', 'ImageToolbar', 'ImageUpload'],
                            toolbar: {
                                items: [
                                    // 'heading', '|',
                                    'bold', 'italic', 'fontSize', 'fontColor', 'fontBackgroundColor', 'alignment', 'underline', 'strikethrough', '|',
                                    'link', 'bulletedList', 'numberedList', '|',
                                    'outdent', 'indent', '|',
                                    'blockQuote', 'insertTable', 'mediaEmbed', 'fontFamily', '|',
                                    'undo', 'redo'
                                ],
                                // removeItems: ['imageUpload'],
                                // shouldNotGroupWhenFull: false
                            },
                            mediaEmbed: {
                                previewsInData: true                // Automatically add preview iframe to <figure> media tag
                            },
                            link: {
                                decorators: {
                                    toggleDownloadable: {
                                        mode: 'manual',
                                        label: 'Downloadable',
                                        attributes: {
                                            download: 'file'
                                        }
                                    },
                                    openInNewTab: {
                                        mode: 'manual',
                                        label: 'Open in a new tab',
                                        defaultValue: true,			// This option will be selected by default.
                                        attributes: {
                                            target: '_blank',
                                            rel: 'noopener noreferrer'
                                        }
                                    }
                                }
                            },
                            mention: {
                                feeds: [
                                    {
                                        marker: '{',
                                        feed: function (queryText) {
                                            const itemsToDisplay = ($('#ckeditor-mention').text() ? JSON.parse($('#ckeditor-mention').text()) : [])
                                                .filter(function (item) {
                                                    const searchString = queryText.toLowerCase();
                                                    return (
                                                        item.toLowerCase().includes(searchString)
                                                    );
                                                });
                                            return itemsToDisplay;
                                        }
                                    }
                                ]
                            }
                        })
                        .then(editor => {
                            _attrModel = $(this).attr('wire:model.live') ?? $(this).attr('wire:model') ?? $(this).attr('wire:model.blur');
                            if ($(this).attr('disabled')) {
                                editor.isReadOnly = true;
                            }
                            if (ckEditors[_attrModel] == 'promised') {
                                editor.model.document.on('change:data', () => {
                                    let wireid = $(this).closest('[wire\\:id]').attr('wire:id');
                                    if (wireid) {
                                        let lwcomp = Livewire.find([wireid]);
                                        let model = $(this).attr('wire:model.live') ?? $(this).attr('wire:model') ?? $(this).attr('wire:model.blur');
                                        if (lwcomp && model) {
                                            lwcomp.set(model, editor.getData());
                                        }
                                    }
                                });
                                ckEditors[_attrModel] = editor;
                            }
                        })
                        .catch(err => {
                            console.error(err.stack);
                        });
                }
            });
        }
    };
}();

var KTMarkdown = function () {
    return {
        // public functions
        init: function (nodezero) {
            var selector = nodezero ? nodezero + ' textarea[data-provide="markdown"]' : 'textarea[data-provide="markdown"]';
            $(selector).each(function () {
                if ($(this).data('markdown')) {
                    $(this).data('markdown').showEditor();
                    return;
                }
				$(this).markdown({
					/*onShow: function (e) { console.log(e); },
					onPreview: function (e) { console.log(e); },
					onPreviewEnd: function (e) { console.log(e); },
					onSave: function (e) { console.log(e); },
					onBlur: function (e) { console.log(e); },
					onFocus: function (e) { console.log(e); },*/
					onChange: function (e) {
						let data =e.$element.val();
						let wireid = e.$element.closest('[wire\\:id]').attr('wire:id');
						if (wireid) {
							let lwcomp = Livewire.find([wireid]);
                            let model = $(this).attr('wire:model.live') ?? $(this).attr('wire:model') ?? $(this).attr('wire:model.blur');
							if (lwcomp && model) {
								lwcomp.set(model, data);
							}
						}
					},
					/*onFullscreen: function (e) { console.log(e); },
					onFullscreenExit: function (e) { console.log(e); },
					onSelect: function (e) { console.log(e); }*/
				});
            });
        }
    };
}();

var KTSelect = function () {
    return {
        // public functions
        init: function (nodezero) {
            var selector = nodezero ? nodezero + ' select[data-toggle="selectpicker"]' : 'select[data-toggle="selectpicker"]';
            // console.log(selector);
            $(selector).each(function (idx, ele) {
                // console.log(idx,ele);
                $(this).selectpicker({ sanitize: false });
                // console.log(this);
            });
            var selector = nodezero ? nodezero + ' select[data-toggle="select2"]' : 'select[data-toggle="select2"]';
            $(selector).each(function (idx, ele) {
                $(this).select2({
                    ajax: $(this).data('ajaxurl') ? {
                        url: function (params) { return $(this).data('ajaxurl'); },
                        dataType: 'json',
                        delay: 500,
                    } : null,
                    templateSelection: $(this).data('template') == 'stubDataContent' ? function (object) {
                        if ($(object.element).data('content')) {
                            return $($(object.element).data('content'));
                        } else if (object.text) {
                            return object.text;
                        }
                    } : null,
                    templateResult: $(this).data('template') == 'stubDataContent' ? function (object) {
                        if ($(object.element).data('content')) {
                            return $($(object.element).data('content'));
                        } else if (object.text) {
                            return object.text;
                        }
                    } : null,
                    escapeMarkup: function (markup) {
                        return markup;
                    }
                }).on('change', function (e) {
                    let data = $(this).select2("val");
                    let wireid = $(this).closest('[wire\\:id]').attr('wire:id');
                    if (wireid) {
                        let lwcomp = Livewire.find([wireid]);
                        let model = $(this).attr('wire:model.live') ?? $(this).attr('wire:model') ?? $(this).attr('wire:model.blur');
                        if (lwcomp && model) {
                            lwcomp.set(model, data);
                        }
                    }
                });
            });
        }
    };
}();

var KTOffcanvasPanel = function () {
    return {
        // public functions
        init: function (nodezero) {
            var selector = nodezero ? nodezero + ' .offcanvas' : '.offcanvas';
            $(selector).each(function (idx, ele) {
                var id = ele.getAttribute('id');

                var header = KTUtil.find(ele, '.offcanvas-header');
                var content = KTUtil.find(ele, '.offcanvas-content');
                var wrapper = KTUtil.find(ele, '.offcanvas-wrapper');
                var footer = KTUtil.find(ele, '.offcanvas-footer');

                _offcanvasObject = new KTOffcanvas(ele, {
                    overlay: true,
                    baseClass: 'offcanvas',
                    closeBy: id + '_close',
                    toggleBy: id + '_toggle'
                });

                KTUtil.scrollInit(wrapper ?? content, {
                    disableForMobile: true,
                    resetHeightOnDestroy: true,
                    handleWindowResize: true,
                    height: function () {
                        var height = parseInt(KTUtil.getViewPort().height);

                        if (header) {
                            height = height - parseInt(KTUtil.actualHeight(header));
                            height = height - parseInt(KTUtil.css(header, 'marginTop'));
                            height = height - parseInt(KTUtil.css(header, 'marginBottom'));
                        }

                        if (content) {
                            height = height - parseInt(KTUtil.css(content, 'marginTop'));
                            height = height - parseInt(KTUtil.css(content, 'marginBottom'));
                        }

                        if (wrapper) {
                            height = height - parseInt(KTUtil.css(wrapper, 'marginTop'));
                            height = height - parseInt(KTUtil.css(wrapper, 'marginBottom'));
                        }

                        if (footer) {
                            height = height - parseInt(KTUtil.actualHeight(footer));
                            height = height - parseInt(KTUtil.css(footer, 'marginTop'));
                            height = height - parseInt(KTUtil.css(footer, 'marginBottom'));
                        }

                        height = height - parseInt(KTUtil.css(ele, 'paddingTop'));
                        height = height - parseInt(KTUtil.css(ele, 'paddingBottom'));

                        height = height - 2;

                        return height;
                    }
                });

                _offcanvasObject.on('afterShow', function () {
                    $(".offcanvas input:text").first().focus();
                });
            });
        }
    };
}();

var KTAsideMenuPanel = function () {
    return {
        // public functions
        init: function (nodezero) {
            var selector = nodezero ? nodezero + ' .aside-menu' : '.aside-menu';
            $(selector).each(function (idx, ele) {
                KTLayoutAsideMenu.init($(this).attr('id'));
            });
        }
    };
}();

var KTCardSticky = function () {
    return {
        // public functions
        init: function (nodezero) {
            var selector = nodezero ? nodezero + ' .card-sticky' : '.card-sticky';
            $(selector).each(function (idx, ele) {
                KTLayoutStickyCard.init($(this).attr('id'));
            });
        }
    };
}();

var KTWizardPanel = function () {
    return {
        // public functions
        init: function (nodezero) {
            var selector = nodezero ? nodezero + ' div[data-toggle="wizard"]' : 'div[data-toggle="wizard"]';
            $(selector).each(function (idx, ele) {
                // var id = ele.getAttribute('id');
                _wizardObj = new KTWizard(ele, {
                    startStep: 1,           // initial active step number
                    clickableSteps: false   // allow step clicking
                });

            });
        }
    };
}();

// Class definition
var KTBlockUI = function () {
    return {
        // public functions
        init: function () {

            $(document).ajaxStart(function () {
                KTApp.blockPage({
                    overlayColor: '#ffffff',
                    state: 'primary',
                    message: 'Please wait while we look-up your request.'
                });
            });

            $(document).ajaxStop(function () {
                KTApp.unblockPage();
            });

        }
    };
}();

// Class definition
var KTInputmask = function () {
    return {
        // public functions
        init: function (nodezero) {
            var selector = nodezero ? nodezero + ' input[data-inputmask]' : 'input[data-inputmask]';
            // console.log($(selector));
            $(selector).inputmask({
                onKeyDown: function (event, buffer, caretPos, opts) {
                    _attrModel = $(this).attr('wire:model.live') ?? $(this).attr('wire:model') ?? $(this).attr('wire:model.blur');
                    if (_attrModel && event.isTrusted) {
                        Livewire.dispatch('setProperty', { [_attrModel]: buffer.join('') })
                    }
                    // console.log(_attrModel, event, buffer, caretPos, opts);
                    // Livewire.dispatch('setProperty', { [_attrModel]: buffer })
                    return buffer;
                }
                // onBeforeMask: function (value, opts) {
                //     _attrModel = $(this).attr('wire:model.live') ?? $(this).attr('wire:model') ?? $(this).attr('wire:model.blur');
                //     Livewire.dispatch('setProperty', { [_attrModel]: value })
                // }
            }
            );
        }
    };
}();

// Class definition
var KTAppInbox = function () {
    // Private properties
    var _asideEl;
    var _listEl;
    var _viewEl;
    var _composeEl;
    var _replyEl;
    var _asideOffcanvas;

    // Private methods
    var _initEditor = function (form, editor) {

        Quill.register('modules/counter', function (quill, options) {
            var container = document.querySelector(options.container);
            quill.on('text-change', function () {
                var text = quill.getText();
                var textLength = text.length - 1;
                var type = container.closest('form').querySelector('[name="type"]:checked').value;
                container.classList.remove('text-danger');
                if (options.unit === 'word') {
                    container.innerText = text.split(/\s+/).length + ' words';
                } else {
                    container.innerText = textLength + ' characters' + (type == 'sms' ? ' / 160' : ' / 1000');
                }

                if (((textLength >= 160) && (type == 'sms')) || ((textLength >= 1000) && (type == 'email'))) {

                    container.classList.remove('text-muted');
                    container.classList.add('text-danger');
                }
            });
        });

        // init editor
        var options = {
            modules: {
                toolbar: {},
                counter: {
                    container: '#' + editor + ' ~ .kt_inbox_compose_editor_counter'
                }
            },
            placeholder: 'Type message...',
            theme: 'snow'
        };

        // Init editor
        var editor = new Quill('#' + editor, options);

        // Customize editor
        var toolbar = KTUtil.find(form, '.ql-toolbar');
        var editor = KTUtil.find(form, '.ql-editor');

        if (toolbar) {
            KTUtil.addClass(toolbar, 'px-5 border-top-0 border-left-0 border-right-0');
        }

        if (editor) {
            KTUtil.addClass(editor, 'px-8');
        }
    }

    var _initForm = function (formEl) {
        var formEl = KTUtil.getById(formEl);

        // Init autocompletes
        var toEl = KTUtil.find(formEl, '[name=compose_to]');
        var tagifyTo = new Tagify(toEl, {
            delimiters: ", ", // add new tags when a comma or a space character is entered
            maxTags: 10,
            blacklist: ["fuck", "shit", "pussy"],
            keepInvalidTags: true, // do not remove invalid tags (but keep them marked as invalid)
            whitelist: [{
                value: 'Chris Muller',
                email: 'chris.muller@wix.com',
                initials: '',
                initialsState: '',
                pic: './assets/media/users/150-11.jpg',
                class: 'tagify__tag--primary'
            }, {
                value: 'Nick Bold',
                email: 'nick.seo@gmail.com',
                initials: 'SS',
                initialsState: 'warning',
                pic: ''
            }, {
                value: 'Alon Silko',
                email: 'alon@keenthemes.com',
                initials: '',
                initialsState: '',
                pic: './assets/media/users/150-6.jpg'
            }, {
                value: 'Sam Seanic',
                email: 'sam.senic@loop.com',
                initials: '',
                initialsState: '',
                pic: './assets/media/users/150-8.jpg'
            }, {
                value: 'Sara Loran',
                email: 'sara.loran@tilda.com',
                initials: '',
                initialsState: '',
                pic: './assets/media/users/150-9.jpg'
            }, {
                value: 'Eric Davok',
                email: 'davok@mix.com',
                initials: '',
                initialsState: '',
                pic: './assets/media/users/150-13.jpg'
            }, {
                value: 'Sam Seanic',
                email: 'sam.senic@loop.com',
                initials: '',
                initialsState: '',
                pic: './assets/media/users/150-13.jpg'
            }, {
                value: 'Lina Nilson',
                email: 'lina.nilson@loop.com',
                initials: 'LN',
                initialsState: 'danger',
                pic: './assets/media/users/150-15.jpg'
            }],
            templates: {
                dropdownItem: function (tagData) {
                    try {
                        var html = '';

                        html += '<div class="tagify__dropdown__item">';
                        html += '   <div class="d-flex align-items-center">';
                        html += '       <span class="symbol sumbol-' + (tagData.initialsState ? tagData.initialsState : '') + ' mr-2">';
                        html += '           <span class="symbol-label" style="background-image: url(\'' + (tagData.pic ? tagData.pic : '') + '\')">' + (tagData.initials ? tagData.initials : '') + '</span>';
                        html += '       </span>';
                        html += '       <div class="d-flex flex-column">';
                        html += '           <a href="#" class="text-dark-75 text-hover-primary font-weight-bold">' + (tagData.value ? tagData.value : '') + '</a>';
                        html += '           <span class="text-muted font-weight-bold">' + (tagData.email ? tagData.email : '') + '</span>';
                        html += '       </div>';
                        html += '   </div>';
                        html += '</div>';

                        return html;
                    } catch (err) { }
                }
            },
            transformTag: function (tagData) {
                tagData.class = 'tagify__tag tagify__tag--primary';
            },
            dropdown: {
                classname: "color-blue",
                enabled: 1,
                maxItems: 5
            }
        });

        var ccEl = KTUtil.find(formEl, '[name=compose_cc]');
        var tagifyCc = new Tagify(ccEl, {
            delimiters: ", ", // add new tags when a comma or a space character is entered
            maxTags: 10,
            blacklist: ["fuck", "shit", "pussy"],
            keepInvalidTags: true, // do not remove invalid tags (but keep them marked as invalid)
            whitelist: [{
                value: 'Chris Muller',
                email: 'chris.muller@wix.com',
                initials: '',
                initialsState: '',
                pic: './assets/media/users/150-11.jpg',
                class: 'tagify__tag--primary'
            }, {
                value: 'Nick Bold',
                email: 'nick.seo@gmail.com',
                initials: 'SS',
                initialsState: 'warning',
                pic: ''
            }, {
                value: 'Alon Silko',
                email: 'alon@keenthemes.com',
                initials: '',
                initialsState: '',
                pic: './assets/media/users/150-6.jpg'
            }, {
                value: 'Sam Seanic',
                email: 'sam.senic@loop.com',
                initials: '',
                initialsState: '',
                pic: './assets/media/users/150-8.jpg'
            }, {
                value: 'Sara Loran',
                email: 'sara.loran@tilda.com',
                initials: '',
                initialsState: '',
                pic: './assets/media/users/150-9.jpg'
            }, {
                value: 'Eric Davok',
                email: 'davok@mix.com',
                initials: '',
                initialsState: '',
                pic: './assets/media/users/150-13.jpg'
            }, {
                value: 'Sam Seanic',
                email: 'sam.senic@loop.com',
                initials: '',
                initialsState: '',
                pic: './assets/media/users/150-13.jpg'
            }, {
                value: 'Lina Nilson',
                email: 'lina.nilson@loop.com',
                initials: 'LN',
                initialsState: 'danger',
                pic: './assets/media/users/150-15.jpg'
            }],
            templates: {
                dropdownItem: function (tagData) {
                    try {
                        var html = '';

                        html += '<div class="tagify__dropdown__item">';
                        html += '   <div class="d-flex align-items-center">';
                        html += '       <span class="symbol sumbol-' + (tagData.initialsState ? tagData.initialsState : '') + ' mr-2" style="background-image: url(\'' + (tagData.pic ? tagData.pic : '') + '\')">';
                        html += '           <span class="symbol-label">' + (tagData.initials ? tagData.initials : '') + '</span>';
                        html += '       </span>';
                        html += '       <div class="d-flex flex-column">';
                        html += '           <a href="#" class="text-dark-75 text-hover-primary font-weight-bold">' + (tagData.value ? tagData.value : '') + '</a>';
                        html += '           <span class="text-muted font-weight-bold">' + (tagData.email ? tagData.email : '') + '</span>';
                        html += '       </div>';
                        html += '   </div>';
                        html += '</div>';

                        return html;
                    } catch (err) { }
                }
            },
            transformTag: function (tagData) {
                tagData.class = 'tagify__tag tagify__tag--primary';
            },
            dropdown: {
                classname: "color-blue",
                enabled: 1,
                maxItems: 5
            }
        });

        var bccEl = KTUtil.find(formEl, '[name=compose_bcc]');
        var tagifyBcc = new Tagify(bccEl, {
            delimiters: ", ", // add new tags when a comma or a space character is entered
            maxTags: 10,
            blacklist: ["fuck", "shit", "pussy"],
            keepInvalidTags: true, // do not remove invalid tags (but keep them marked as invalid)
            whitelist: [{
                value: 'Chris Muller',
                email: 'chris.muller@wix.com',
                initials: '',
                initialsState: '',
                pic: './assets/media/users/150-11.jpg',
                class: 'tagify__tag--primary'
            }, {
                value: 'Nick Bold',
                email: 'nick.seo@gmail.com',
                initials: 'SS',
                initialsState: 'warning',
                pic: ''
            }, {
                value: 'Alon Silko',
                email: 'alon@keenthemes.com',
                initials: '',
                initialsState: '',
                pic: './assets/media/users/150-6.jpg'
            }, {
                value: 'Sam Seanic',
                email: 'sam.senic@loop.com',
                initials: '',
                initialsState: '',
                pic: './assets/media/users/150-8.jpg'
            }, {
                value: 'Sara Loran',
                email: 'sara.loran@tilda.com',
                initials: '',
                initialsState: '',
                pic: './assets/media/users/150-9.jpg'
            }, {
                value: 'Eric Davok',
                email: 'davok@mix.com',
                initials: '',
                initialsState: '',
                pic: './assets/media/users/150-13.jpg'
            }, {
                value: 'Sam Seanic',
                email: 'sam.senic@loop.com',
                initials: '',
                initialsState: '',
                pic: './assets/media/users/150-13.jpg'
            }, {
                value: 'Lina Nilson',
                email: 'lina.nilson@loop.com',
                initials: 'LN',
                initialsState: 'danger',
                pic: './assets/media/users/150-15.jpg'
            }],
            templates: {
                dropdownItem: function (tagData) {
                    try {
                        var html = '';

                        html += '<div class="tagify__dropdown__item">';
                        html += '   <div class="d-flex align-items-center">';
                        html += '       <span class="symbol sumbol-' + (tagData.initialsState ? tagData.initialsState : '') + ' mr-2" style="background-image: url(\'' + (tagData.pic ? tagData.pic : '') + '\')">';
                        html += '           <span class="symbol-label">' + (tagData.initials ? tagData.initials : '') + '</span>';
                        html += '       </span>';
                        html += '       <div class="d-flex flex-column">';
                        html += '           <a href="#" class="text-dark-75 text-hover-primary font-weight-bold">' + (tagData.value ? tagData.value : '') + '</a>';
                        html += '           <span class="text-muted font-weight-bold">' + (tagData.email ? tagData.email : '') + '</span>';
                        html += '       </div>';
                        html += '   </div>';
                        html += '</div>';

                        return html;
                    } catch (err) { }
                }
            },
            transformTag: function (tagData) {
                tagData.class = 'tagify__tag tagify__tag--primary';
            },
            dropdown: {
                classname: "color-blue",
                enabled: 1,
                maxItems: 5
            }
        });

        // CC input show
        KTUtil.on(formEl, '[data-inbox="cc-show"]', 'click', function (e) {
            var inputEl = KTUtil.find(formEl, '.inbox-to-cc');
            KTUtil.removeClass(inputEl, 'd-none');
            KTUtil.addClass(inputEl, 'd-flex');
            KTUtil.find(formEl, "[name=compose_cc]").focus();
        });

        // CC input hide
        KTUtil.on(formEl, '[data-inbox="cc-hide"]', 'click', function (e) {
            var inputEl = KTUtil.find(formEl, '.inbox-to-cc');
            KTUtil.removeClass(inputEl, 'd-flex');
            KTUtil.addClass(inputEl, 'd-none');
        });

        // BCC input show
        KTUtil.on(formEl, '[data-inbox="bcc-show"]', 'click', function (e) {
            var inputEl = KTUtil.find(formEl, '.inbox-to-bcc');
            KTUtil.removeClass(inputEl, 'd-none');
            KTUtil.addClass(inputEl, 'd-flex');
            KTUtil.find(formEl, "[name=compose_bcc]").focus();
        });

        // BCC input hide
        KTUtil.on(formEl, '[data-inbox="bcc-hide"]', 'click', function (e) {
            var inputEl = KTUtil.find(formEl, '.inbox-to-bcc');
            KTUtil.removeClass(inputEl, 'd-flex');
            KTUtil.addClass(inputEl, 'd-none');
        });
    }

    var _initAttachments = function (elemId) {
        var id = "#" + elemId;
        var previewNode = $(id + " .dropzone-item");
        previewNode.id = "";
        var previewTemplate = previewNode.parent('.dropzone-items').html();
        previewNode.remove();

        var myDropzone = new Dropzone(id, { // Make the whole body a dropzone
            url: "https://keenthemes.com/scripts/void.php", // Set the url for your upload script location
            parallelUploads: 20,
            maxFilesize: 1, // Max filesize in MB
            previewTemplate: previewTemplate,
            previewsContainer: id + " .dropzone-items", // Define the container to display the previews
            clickable: id + "_select" // Define the element that should be used as click trigger to select files.
        });

        myDropzone.on("addedfile", function (file) {
            // Hookup the start button
            $(document).find(id + ' .dropzone-item').css('display', '');
        });

        // Update the total progress bar
        myDropzone.on("totaluploadprogress", function (progress) {
            document.querySelector(id + " .progress-bar").style.width = progress + "%";
        });

        myDropzone.on("sending", function (file) {
            // Show the total progress bar when upload starts
            document.querySelector(id + " .progress-bar").style.opacity = "1";
        });

        // Hide the total progress bar when nothing's uploading anymore
        myDropzone.on("complete", function (progress) {
            var thisProgressBar = id + " .dz-complete";
            setTimeout(function () {
                $(thisProgressBar + " .progress-bar, " + thisProgressBar + " .progress").css('opacity', '0');
            }, 300)
        });
    }

    // Public methods
    return {
        // Public functions
        init: function () {
            // Init variables
            _asideEl = KTUtil.getById('kt_inbox_aside');
            _listEl = KTUtil.getById('kt_inbox_list');
            _viewEl = KTUtil.getById('kt_inbox_view');
            _composeEl = KTUtil.getById('kt_inbox_compose');
            _replyEl = KTUtil.getById('kt_inbox_reply');

            // Init handlers
            if ($('#kt_inbox').length) {
                KTAppInbox.initAside();
                KTAppInbox.initList();
                KTAppInbox.initView();
                KTAppInbox.initReply();
                KTAppInbox.initCompose();
            }
        },

        initAside: function () {
            // Mobile offcanvas for mobile mode
            _asideOffcanvas = new KTOffcanvas(_asideEl, {
                overlay: true,
                baseClass: 'offcanvas-mobile',
                //closeBy: 'kt_inbox_aside_close',
                toggleBy: 'kt_subheader_mobile_toggle'
            });

            // View list
            KTUtil.on(_asideEl, '.list-item[data-action="list"]', 'click', function (e) {
                var type = KTUtil.attr(this, 'data-type');
                var listItemsEl = KTUtil.find(_listEl, '.kt-inbox__items');
                var navItemEl = this.closest('.kt-nav__item');
                var navItemActiveEl = KTUtil.find(_asideEl, '.kt-nav__item.kt-nav__item--active');

                // demo loading
                var loading = new KTDialog({
                    'type': 'loader',
                    'placement': 'top center',
                    'message': 'Loading ...'
                });
                loading.show();

                setTimeout(function () {
                    loading.hide();

                    KTUtil.css(_listEl, 'display', 'flex'); // show list
                    KTUtil.css(_viewEl, 'display', 'none'); // hide view

                    KTUtil.addClass(navItemEl, 'kt-nav__item--active');
                    KTUtil.removeClass(navItemActiveEl, 'kt-nav__item--active');

                    KTUtil.attr(listItemsEl, 'data-type', type);
                }, 600);
            });
        },

        initList: function () {
            // View message
            KTUtil.on(_listEl, '[data-inbox="message"]', 'click', function (e) {
                var actionsEl = KTUtil.find(this, '[data-inbox="actions"]');

                // skip actions click
                if (e.target === actionsEl || (actionsEl && actionsEl.contains(e.target) === true)) {
                    return false;
                }

                // Demo loading
                var loading = new KTDialog({
                    'type': 'loader',
                    'placement': 'top center',
                    'message': 'Loading ...'
                });
                loading.show();

                setTimeout(function () {
                    loading.hide();

                    KTUtil.addClass(_listEl, 'd-none');
                    KTUtil.removeClass(_listEl, 'd-block');

                    KTUtil.addClass(_viewEl, 'd-block');
                    KTUtil.removeClass(_viewEl, 'd-none');
                }, 700);
            });

            // Group selection
            KTUtil.on(_listEl, '[data-inbox="group-select"] input', 'click', function () {
                var messages = KTUtil.findAll(_listEl, '[data-inbox="message"]');

                for (var i = 0, j = messages.length; i < j; i++) {
                    var message = messages[i];
                    var checkbox = KTUtil.find(message, '.checkbox input');
                    checkbox.checked = this.checked;

                    if (this.checked) {
                        KTUtil.addClass(message, 'active');
                    } else {
                        KTUtil.removeClass(message, 'active');
                    }
                }
            });

            // Individual selection
            KTUtil.on(_listEl, '[data-inbox="message"] [data-inbox="actions"] .checkbox input', 'click', function () {
                var item = this.closest('[data-inbox="message"]');

                if (item && this.checked) {
                    KTUtil.addClass(item, 'active');
                } else {
                    KTUtil.removeClass(item, 'active');
                }
            });
        },

        initView: function () {
            // Back to listing
            KTUtil.on(_viewEl, '[data-inbox="back"]', 'click', function () {
                // demo loading
                var loading = new KTDialog({
                    'type': 'loader',
                    'placement': 'top center',
                    'message': 'Loading ...'
                });

                loading.show();

                setTimeout(function () {
                    loading.hide();

                    KTUtil.addClass(_listEl, 'd-block');
                    KTUtil.removeClass(_listEl, 'd-none');

                    KTUtil.addClass(_viewEl, 'd-none');
                    KTUtil.removeClass(_viewEl, 'd-block');
                }, 700);
            });

            // Expand/Collapse reply
            KTUtil.on(_viewEl, '[data-inbox="message"]', 'click', function (e) {
                var message = this.closest('[data-inbox="message"]');

                var dropdownToggleEl = KTUtil.find(this, '[data-toggle="dropdown"]');
                var toolbarEl = KTUtil.find(this, '[data-inbox="toolbar"]');

                // skip dropdown toggle click
                if (e.target === dropdownToggleEl || (dropdownToggleEl && dropdownToggleEl.contains(e.target) === true)) {
                    return false;
                }

                // skip group actions click
                if (e.target === toolbarEl || (toolbarEl && toolbarEl.contains(e.target) === true)) {
                    return false;
                }

                if (KTUtil.hasClass(message, 'toggle-on')) {
                    KTUtil.addClass(message, 'toggle-off');
                    KTUtil.removeClass(message, 'toggle-on');
                } else {
                    KTUtil.removeClass(message, 'toggle-off');
                    KTUtil.addClass(message, 'toggle-on');
                }
            });
        },

        initReply: function () {
            _initEditor(_replyEl, 'kt_inbox_reply_editor');
            _initAttachments('kt_inbox_reply_attachments');
            _initForm('kt_inbox_reply_form');
        },

        initCompose: function () {
            _initEditor(_composeEl, 'kt_inbox_compose_editor');
            _initAttachments('kt_inbox_compose_attachments');
            _initForm('kt_inbox_compose_form');

            // Remove reply form
            KTUtil.on(_composeEl, '[data-inbox="dismiss"]', 'click', function (e) {
                swal.fire({
                    text: "Are you sure to discard this message ?",
                    type: "danger",
                    buttonsStyling: false,
                    confirmButtonText: "Discard draft",
                    confirmButtonClass: "btn btn-danger",
                    showCancelButton: true,
                    cancelButtonText: "Cancel",
                    cancelButtonClass: "btn btn-light-primary"
                }).then(function (result) {
                    $(_composeEl).modal('hide');
                });
            });
        }
    };
}();

var NPAsideToggle = function () {
    return {
        // public functions
        init: function (nodezero) {
            // toggle aside on main nav click
            $('.aside-primary .aside-nav .nav-item').on('click', function () {
                if ($('body').hasClass('aside-minimize')) {
                    $('body').removeClass('aside-minimize aside-minimized');
                    $('#kt_aside_toggle').triggerNative('click');
                }
            });
        }
    };
}();

var NPToggleAccordionOnTab = function () {
    return {
        // public functions
        init: function (nodezero) {
            // toggle aside on main nav click
            $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
                let _elem = $(this).closest('.card-collapsed');
                if (_elem.length) {
                    $(_elem).find('[data-card-tool="toggle"]').triggerNative('click');
                }
            });
        }
    };
}();

var NPScrollabeTabs = function () {
    return {
        // public functions
        init: function (nodezero) {
            $('.scrollable-tabs .nav-tabs, .scrollable-tabs .nav-pills').scrollingTabs({
                cssClassLeftArrow: 'far fa-chevron-left',
                cssClassRightArrow: 'far fa-chevron-right',
                enableSwiping: true,
                scrollToTabEdge: true,
                bootstrapVersion: 4
            }).on('ready.scrtabs', function () {
                $('.tab-content').show();
            });
        }
    };
}();

var KTTooltips = function () {
	return {
		init: function (nodezero) {

			// dispose tooltips before re initializing
			$("[data-toggle='tooltip']").tooltip('dispose');

			initTooltip = function (el) {
				var theme = el.data('theme') ? 'tooltip-' + el.data('theme') : '';
				var width = el.data('width') == 'auto' ? 'tooltop-auto-width' : '';
				var trigger = el.data('trigger') ? el.data('trigger') : 'hover';

				$(el).tooltip({
					trigger: trigger,
					template: '<div class="tooltip ' + theme + ' ' + width + '" role="tooltip">\
						<div class="arrow"></div>\
						<div class="tooltip-inner"></div>\
					</div>'
				});
			}

			$('[data-toggle="tooltip"]').each(function () {
				initTooltip($(this));
			});
		}
	}
}();


var KTPopovers = function () {
	return {
		init: function (nodezero) {

			// dispose popovers before re initializing
			$("[data-toggle='popover']").popover('dispose');

			initPopover = function (el) {
				var skin = el.data('skin') ? 'popover-' + el.data('skin') : '';
				var triggerValue = el.data('trigger') ? el.data('trigger') : 'hover';

				el.popover({
					trigger: triggerValue,
					template: '\
					<div class="popover ' + skin + '" role="tooltip">\
						<div class="arrow"></div>\
						<h3 class="popover-header"></h3>\
						<div class="popover-body"></div>\
					</div>'
				});
			}

			$('[data-toggle="popover"]').each(function () {
				initPopover($(this));
			});
		}
	}
}();


Livewire.hook('morphed',  ({ el, component }) => {
    // console.log(el, component, 'div[wire:id="'+component.id+'"]');
    BasicBootstrap('div[wire\\:id="'+component.id+'"]');
})

Livewire.hook('request', ({ fail }) => {
    fail(({ status, preventDefault }) => {
        if (status === 419) {
            preventDefault()
            alert('Web session expired, proceed to login again.');
            location.reload();
        }
    })
})